import { Data, NeoModel } from '@singularsystems/neo-core';
import { AppService, Types } from '../../AwardsTypes';
import MyAwardLookup from '../../Models/ParticipantOffers/Queries/MyAwards/MyAwardLookup';
import MyAwardLookupCriteria from '../../Models/ParticipantOffers/Queries/MyAwards/MyAwardLookupCriteria';
import MyAwardsVMBase from './MyAwardsVMBase';
import UndoAwardResponseCommand from '../../Models/ParticipantOffers/Commands/UndoAwardResponseCommand';

@NeoModel
export default class MyAwardsVM extends MyAwardsVMBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private participantAcceptanceCommandApiClient = AppService.get(Types.Awards.ApiClients.ParticipantAcceptanceCommandApiClient)) {
        super(taskRunner);
    }

    private acceptedAwardsCriteria = new MyAwardLookupCriteria();

    public acceptedAwardsPageManager = new Data.PageManager(this.acceptedAwardsCriteria, MyAwardLookup, (request) => this.myAwardsApiClient.getAwardResponses(request, null), {
        pageSize: 6,
        initialTaskRunner: this.taskRunner,
        sortBy: "awardDate",
        sortAscending: false,
        afterFetch: (data) => this.setupAwardsResponsesData(data)
    });

    public hasPendingAwards = false;
    public hasAcceptedAwards = false;

    public async initialise() {
        // get the base to start loading
        const resultTask = this.taskRunner.waitFor(super.initialise());

        this.myAwardInfoTaskRunner.run(async () => {
            const result = await this.myAwardsApiClient.getPendingAwardInfo();
            this.myAwardsInfoLookup.set(result.data);
        });

        // then start loading the pages
        this.pendingAwardsPageManager.refreshData();
        this.acceptedAwardsCriteria.ignoreCancelledAwards = true;
        this.acceptedAwardsPageManager.refreshData();

        // wait for the initial task to finish loading
        await resultTask;
        this.initialising = true;

        // then try setup the data again
        await this.setupPendingAwardsData(this.pendingAwardsPageManager.data);
        this.setupAwardsResponsesData(this.acceptedAwardsPageManager.data);

        this.initialising = false;
    }

    protected async setupPendingAwardsData(data: MyAwardLookup[]) {
        await super.setupPendingAwardsData(data);
        this.hasPendingAwards = data.length > 0;
    }

    private async setupAwardsResponsesData(data: MyAwardLookup[]) {
        await this.setupData(data);
        this.hasAcceptedAwards = data.length > 0;
    }

    public async undoAwardResponse(award: MyAwardLookup): Promise<void> {
        const command = new UndoAwardResponseCommand();
        command.participantOfferIds = [award.participantOfferId];

        await this.taskRunner.run(async () => {
            await this.participantAcceptanceCommandApiClient.undoAwardResponse(command.toJSObject());
            this.pendingAwardsPageManager.refreshData();
            this.acceptedAwardsPageManager.refreshData();
        });
    }
}